"use strict";
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");
var ui_extensions = require("ui-extensions");
var cio_config = require("cio-config");

var PathHandleModel = function (object, editorModel) {
    var self = this;

    this.makeObservableTreeNode();

    this.editorModel = editorModel;
    this.object = object;

    this.coord = this.value("coord", true);
    this.coord(object.endpoint().copy());

    this.selected = this.value("selected", true);
    this.highlighted = this.value("highlighted", true);
    this.activeFlag = this.value("activeFlag", true);

    var pathData = this.object.parent();
    var im = this.editorModel.interactionModelDataMap.get(pathData);
    this.interactionModel = im;

    this.next_segment = null;
    this.prev_segment = null;

    // needed for move() function of snapGroupModel
    this.pos = this.shadow("pos",
        function () {
            return self.coord();
        },
        function (newPos) {
            return self.coord(newPos);
        },
        [this.coord]
    );

    this.coord.onChange(this, function(){
        if(!self.coord().eq(self.object.endpoint())) {
            self.object.endpoint(self.coord().copy());
        }
    },10);

    this.object.endpoint.onChange(this, function () {
        if(!self.coord().eq(self.object.endpoint()))
            self.coord(self.object.endpoint().copy());
    }, 10);

    this.selected.onChange("selected_infocus", function(value) {
        if(self.parent()) self.parent().infocus(value);
    },10);

    this.onInit("onInit", this.initialize, 10);
};
lib_core.mixin(PathHandleModel, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PathHandleModel, "PathHandleModel");

module.exports = PathHandleModel;

PathHandleModel.prototype.initialize = function() {
    var self = this;

    //Shadows for inspector
    this.origin = this.parent().origin;

    if (this.origin) {
        this.showX = this.shadow("showX",
            function () {
                return self.origin.getCoordRelative(self.coord()).x;
            },
            function (value) {
                var new_pos = self.coord().copy();
                new_pos.x = self.origin.convertX(value);
                return self.coord(new_pos);
            },
            [this.coord, this.origin]
        );

        this.showY = this.shadow("showY",
            function () {
                return self.origin.getCoordRelative(self.coord()).y;
            },
            function (value) {
                var new_pos = self.coord().copy();
                new_pos.y = self.origin.convertY(value);
                return self.coord(new_pos);
            },
            [this.coord, this.origin]
        );
    }
};


PathHandleModel.prototype.next = function () {
    var index = this.parent().handles.indexOf(this);
    if (index < this.parent().handles.size() -1){
        return this.parent().handles.get(index+1);
    } else {
        if(this.parent().data.closed())
            return this.parent().handles.get(0);
        else
            return;
    }
};

PathHandleModel.prototype.prev = function () {
    var index = this.parent().handles.indexOf(this);
    if (index > 0) {
        return this.parent().handles.get(index-1);
    } else {
        if(this.parent().data.closed())
            return this.parent().handles.get(-1);
        else
            return;
    }
};

PathHandleModel.prototype.remove = function () {
    var path = this.object.parent();
    var index = this.object.index();
    var next = this.object.next();

    if (path.objects.size() > 2) {
        if (this.object.type() == cio_datamodel.PathType.POINT && next) {
            next.tan_0(new lib_geometry.Coord(0, 0));
            next.tan_1(new lib_geometry.Coord(0, 0));
            next.type(cio_datamodel.PathType.POINT);
        }
        path.objects.remove(index);
    } else {
        path.remove();
    }
};

PathHandleModel.prototype.getSnapSet = function (type) {
    var snapSet = new editor_2d.SnapSet();
    if (!this.coord()) return snapSet;

    if(this.interactionModel && this.interactionModel.getSnapFilter) {
        snapSet.setFilter(this.interactionModel.getSnapFilter());
    }

    switch (type) {
        case editor_2d.SnapLineType.TO:
            snapSet.addHor(this.coord(), 1, 0, null, this.parent(), 0, "handle");
            snapSet.addVer(this.coord(), 1, 0, null, this.parent(), 0, "handle");
            break;
        case editor_2d.SnapLineType.FROM:
            snapSet.add(this.coord(), 1, 0, null, this.parent(), 0, "handle");
            break;
    }

    return snapSet;
};

PathHandleModel.prototype.move = function (vec) {
    if(this.next_segment)
        this.next_segment.beforeMoveStartPoint(vec);
    if(this.prev_segment)
        this.prev_segment.beforeMoveEndPoint(vec);
    this.coord(this.coord().add(vec));
    if(this.next_segment)
        this.next_segment.afterMoveStartPoint(vec);
    if(this.prev_segment)
        this.prev_segment.afterMoveEndPoint(vec);
};

// PathHandleModel.prototype.doubleClickAction = function () {
//     this.root.rec();
//     switch (this.mode()) {
//         case cio_datamodel.PathPointMode.STRAIGHT:
//             if (this.isPathEndpoint) {
//                 this.convertToMode(cio_datamodel.PathPointMode.ANGLE);
//             } else {
//                 this.convertToMode(cio_datamodel.PathPointMode.SMOOTH);
//             }
//             break;
//         case cio_datamodel.PathPointMode.SMOOTH:
//             this.convertToMode(cio_datamodel.PathPointMode.ANGLE);
//             break;
//         case cio_datamodel.PathPointMode.ANGLE:
//             this.convertToMode(cio_datamodel.PathPointMode.ARC);
//             break;
//         case cio_datamodel.PathPointMode.ARC:
//             this.convertToMode(cio_datamodel.PathPointMode.STRAIGHT);
//             break;
//         default:
//             break;
//     }
//     this.root.stopRec();
// };

PathHandleModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

PathHandleModel.prototype.getInspectorElements = function () {
    var inspectorElements = this.parent().getInspectorElements();

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.PATH_SMOOTH_BEZIER_CONVERT).element(this);
    if(!this.object.isOuterPoint())
        inspectorElements.input_elements.unshift(
            {
                label       : 'Create Smooth Bezier Point',
                type        : ui_extensions.InspectorInputType.BUTTON,
                cEvent      : cEvent
            });
    inspectorElements.input_elements.unshift(
        {
            label       : 'X',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showX,
            datatype    : cio_config.types.float,
            unitmember : this.origin.showUnitString
        },
        {
            label       : 'Y',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showY,
            datatype    : cio_config.types.float,
            unitmember : this.origin.showUnitString
        }
    );

    inspectorElements.help_elements = {
        'name': 'Path Handle'
    };

    return inspectorElements;
};

PathHandleModel.prototype.getSubSnapSet = function (snapSet) {
    snapSet.addHor(this.object.endpoint(), 1, 0, null, this, 0, null);
    snapSet.addVer(this.object.endpoint(), 1, 0, null, this, 0, null);
};

PathHandleModel.prototype.getOtherSegment = function(seg) {
    if(this.next_segment === seg)
        return this.prev_segment;
    else
        return this.next_segment;
};

PathHandleModel.prototype.convertToSmoothBezierPoint = function () {
    var object = this.object;
    var prev = object.previous();
    var next = object.next();

    var po_seg = new lib_geometry.Segment(prev.endpoint(), object.endpoint());
    var on_seg = new lib_geometry.Segment(object.endpoint(), next.endpoint());
    var t = po_seg.getPoint(2/3).add(on_seg.getPoint(-1/3)).mult(1/2);

    if(object.type() !== cio_datamodel.PathType.CURVEC)
        object.tan_0(po_seg.getPoint(1/3));
    object.tan_1(t);
    next.tan_0(t.flip(object.endpoint()));
    if(next.type() !== cio_datamodel.PathType.CURVEC)
        next.tan_1(on_seg.getPoint(2/3));
    object.type(cio_datamodel.PathType.CURVEC);
    next.type(cio_datamodel.PathType.CURVEC);

    if(this.next_segment && this.next_segment.tan_0)
        this.next_segment.tan_0().symmetrical(true);
    if(this.prev_segment && this.prev_segment.tan_1)
        this.prev_segment.tan_1().symmetrical(true);
};

PathHandleModel.prototype.doubleClickAction = function (coord, subelement) {
    if(!this.object.isOuterPoint())
        this.convertToSmoothBezierPoint();
};